"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _convertJsonToTenantCultureDto = require("./convertJsonToTenantCultureDto");
Object.keys(_convertJsonToTenantCultureDto).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _convertJsonToTenantCultureDto[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _convertJsonToTenantCultureDto[key];
    }
  });
});
var _cultureSettingsToCultureContext = require("./cultureSettingsToCultureContext");
Object.keys(_cultureSettingsToCultureContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cultureSettingsToCultureContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cultureSettingsToCultureContext[key];
    }
  });
});
